import { ItemMedia } from "@/app/item/view/item-media"
import { getItemHref } from "@/app/navigation/item"
import type { ActivityWithNft } from "@anaconda/core/activity/types"
import type { MinimalDrop } from "@anaconda/core/drop/types"
import { useLingui } from "@lingui/react/macro"
import { Skeleton, cn } from "@rarible_int/anaconda_ui_components"
import Link from "next/link"

interface Props {
  nft: ActivityWithNft["nft"]
  className?: string
}

export function NftMiniature({ nft, className }: Props) {
  const { t } = useLingui()

  return (
    <Link
      href={getItemHref(nft.id)}
      className={cn("flex w-full items-center gap-3", className)}
      prefetch={false}
    >
      <div className="relative aspect-square w-8 flex-shrink-0 overflow-hidden rounded-sm">
        <ItemMedia
          src={nft.image}
          alt={t`Image for ${nft.name} item`}
          className="object-contain"
        />
      </div>
      <span className="truncate">{nft.name}</span>
    </Link>
  )
}

export function DropMintMiniature({ drop }: { drop: MinimalDrop }) {
  const { t } = useLingui()

  return (
    <div className="relative aspect-square w-8 flex-shrink-0 overflow-hidden rounded-sm">
      <ItemMedia
        src={drop.media.url}
        type={drop.media.type}
        alt={t`Image for ${drop.title} item`}
        className="object-contain"
      />
    </div>
  )
}

export function NftMiniatureImage({ nft }: Props) {
  const { t } = useLingui()

  return (
    <Link
      href={getItemHref(nft.id)}
      className="flex w-full items-center gap-3"
      prefetch={false}
    >
      <div className="relative aspect-square w-8 flex-shrink-0 overflow-hidden rounded-sm">
        <ItemMedia
          src={nft.image}
          alt={t`Image for ${nft.name} item`}
          className="object-contain"
        />
      </div>
    </Link>
  )
}

export function NftMiniatureSkeleton() {
  return (
    <div className="flex w-full items-center gap-3">
      <Skeleton className="h-8 w-8" />
      <Skeleton className="h-6 w-[80px]" />
    </div>
  )
}
